<template>
<div class="cotainer">
	   <!--<img src="../../assets/images/xin/logo.png" class="logo-img" alt="" />-->
	  <p class="logo-title">山西省职业教育铸魂育人计划项目监测与管理平台</p>
	  <div class="center-wz">
	  	<div class="wz-item"  @click="
            jumpPage({
              name: 'szStudio',
            })
          ">思政教育工作室</div>
	  	<div class="wz-item"  @click="
            jumpPage({
              name: 'educationalBrand',
            })
          ">特色文化育人品牌</div>
	  	<div class="wz-item"   @click="
            jumpPage({
              name: 'szMicroClass',
            })
          ">思政微课</div>
	  </div>
	  <p class="gdt">山西省教育厅</p>
</div>
</template>

<script>
export default{
	data(){
		return {
			
		}
	},
	methods:{
		jumpPage(path){
			 if (this.$store.state.token === null) {
		        this.$router.push({
		        	path:'/login',
//		        	query:{
//		        		name: path.name,
//		        	}
		        });
		      } else {
		        this.$router.push({ name: path.name });
		      }
		}
	}
}
</script>

<style lang="scss" scoped>
.cotainer{
  height: 100vh;
  background: url("../../assets/images/xin/ibg.png") no-repeat; 
  background-repeat: no-repeat;
  overflow: auto;
  background-size: 100% 100%;
}
.logo-img{
	width:135px;
	height:135px;
	display: block;
	margin:6vh auto 0px;
}
.logo-title{
font-weight: bold;
font-size: 40px;
color: #FFFFFF;
line-height: 60px;
background: linear-gradient(0deg, #FFFFFF 0%, #00F6FF 100%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
text-align: center;
margin-top:18vh;
margin-bottom:20px;
}
@media screen and (max-width: 1366px) {
	.logo-img{
		width:135px;
		height:135px;
		display: block;
		margin:2vh auto 0px;
    }
    .logo-title{
    	line-height: 50px;
    	font-size: 36px;
    }
	.center-wz{
	width: 880px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 40px auto 0px;
	.wz-item:nth-child(1){
		width:242px;
		height:302px;
		background: url("../../assets/images/xin/i1.png") no-repeat; 
		background-repeat: no-repeat;
		background-size: 100% 100%;
		padding:180px 60px 20px;
		box-sizing: border-box;
		font-weight: bold;
		font-size: 30px;
		color: #FFFFFF;
		 text-align: center;
		 cursor:pointer;
		 transition: transform 0.3s ease;
	}
	.wz-item:nth-child(2){
		width:242px;
		height:302px;
		background: url("../../assets/images/xin/i2.png") no-repeat; 
		background-repeat: no-repeat;
		background-size: 100% 100%;
		padding:180px 60px 20px;
		box-sizing: border-box;
		font-weight: bold;
		font-size: 30px;
		color: #FFFFFF;
		 text-align: center;
		  cursor:pointer;
		  transition: transform 0.3s ease;
	}
	.wz-item:nth-child(3){
		width:242px;
		height:302px;
		background: url("../../assets/images/xin/i3.png") no-repeat; 
		background-repeat: no-repeat;
		background-size: 100% 100%;
	    padding:180px 60px 20px;
	    text-align: center;
		box-sizing: border-box;
		font-weight: bold;
		font-size: 30px;
		color: #FFFFFF;
		cursor:pointer;
		line-height: 100px;
		transition: transform 0.3s ease;
	}
}
.gdt{
	position: fixed;
	height:30px;
	line-height: 30px;
	text-align: center;
	color:#fff;
	font-size: 16px;
	bottom:0px;
	width:100%;
	margin-bottom:10px;
}
}
@media screen and (min-width: 1367px) {
   .center-wz{
	margin-top:100px;
	width:1000px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin:100px auto 0px;
	.wz-item:nth-child(1){
		width:282px;
		height:402px;
		background: url("../../assets/images/xin/i1.png") no-repeat; 
		background-repeat: no-repeat;
		background-size: 100% 100%;
		padding:250px 60px 20px;
		box-sizing: border-box;
		font-weight: bold;
		font-size: 35px;
		color: #FFFFFF;
		 text-align: center;
		 cursor:pointer;
		 transition: transform 0.3s ease;
	}
	.wz-item:nth-child(2){
		width:282px;
		height:402px;
		background: url("../../assets/images/xin/i2.png") no-repeat; 
		background-repeat: no-repeat;
		background-size: 100% 100%;
		padding:250px 60px 20px;
		box-sizing: border-box;
		font-weight: bold;
		font-size: 35px;
		color: #FFFFFF;
		 text-align: center;
		  cursor:pointer;
		  transition: transform 0.3s ease;
	}
	.wz-item:nth-child(3){
		width:282px;
		height:402px;
		background: url("../../assets/images/xin/i3.png") no-repeat; 
		background-repeat: no-repeat;
		background-size: 100% 100%;
	    padding:250px 60px 20px;
	    text-align: center;
		box-sizing: border-box;
		font-weight: bold;
		font-size: 35px;
		color: #FFFFFF;
		cursor:pointer;
		line-height: 80px;
		transition: transform 0.3s ease;
	}
}
.gdt{
	position: fixed;
	height:30px;
	line-height: 30px;
	text-align: center;
	color:#fff;
	font-size: 20px;
	bottom:15px;
	width:100%;
	margin-bottom:0px;
}
}

 .wz-item:hover  {
      animation: bounce 0.6s;
    }

    @keyframes bounce {
      0%, 100% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(-10px);
      }
    }
</style>